import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_shopping-bag",
  "use": "svg_shopping-bag-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg_shopping-bag\"><path fill=\"currentColor\" d=\"M12.896 4.5V2.922A2.926 2.926 0 0 0 9.973 0H8.027a2.926 2.926 0 0 0-2.923 2.922V4.5H2.25V18h13.5V4.5h-2.854zm-6.75-1.578c0-1.037.844-1.881 1.881-1.881h1.947c1.037 0 1.881.844 1.881 1.881V4.5H6.146V2.922zm8.479 13.953H3.375V5.625h1.729v1.293h1.042V5.625h5.708v1.293h1.042V5.625h1.729v11.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol